export default "__VITE_ASSET__BcepkYFq__"